import { render, staticRenderFns } from "./MyRadioGroup.vue?vue&type=template&id=07f8ba8a&scoped=true&"
import script from "./MyRadioGroup.vue?vue&type=script&lang=ts&"
export * from "./MyRadioGroup.vue?vue&type=script&lang=ts&"
import style0 from "./MyRadioGroup.vue?vue&type=style&index=0&id=07f8ba8a&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f8ba8a",
  null
  
)

export default component.exports